import { BackButton, Button, ImageWithRetry } from "@src/components/atoms";
import { useDCContext } from "@src/context/dcContext";
import { useOperatorContext } from "@src/context/operatorContext";

const IndustryStep = ({
  onNext,
  onBack,
  step,
  previous,
  stepKey,
  contentText,
  imageSrc,
}) => {
  const { getDynamicReplacement, existsDynamicReplacements } = useDCContext();
  const hasImage =
    imageSrc || existsDynamicReplacements(`onboarding__${stepKey}__image`);
  return (
    <div
      className={`h-full flex flex-col sm:px-2 animate-animated animate-fast ${
        previous < step ? "animate-fadeInRight" : "animate-fadeInLeft"
      }`}
    >
      <div className="grow text-center">
        <div className="flex justify-center py-2">
          <h3 className="leading-none font-extrabold text-center">
            {getDynamicReplacement(`onboarding__${stepKey}__title`)}
          </h3>
        </div>
        <div className="flex justify-center py-4 md:py-6">
          <p className="text-base font-medium">
            {contentText ??
              getDynamicReplacement(`onboarding__${stepKey}__content`)}
          </p>
        </div>
        {hasImage && (
          <div className="flex justify-center pb-2 pt-6 min-h-24">
            <ImageWithRetry
              className="w-full mx-auto"
              src={
                imageSrc ??
                getDynamicReplacement(`onboarding__${stepKey}__image`)
              }
              alt=""
            />
          </div>
        )}
      </div>
      <div className="flex justify-center items-center pt-4 md:pt-6 relative">
        <div className="absolute left-0 p-1">
          <BackButton onCustomBack={onBack} noContainer />
        </div>
        <div>
          <Button
            onClick={onNext}
            className="px-4 py-2"
            children={getDynamicReplacement("onboarding__texts__next_button")}
          />
        </div>
      </div>
    </div>
  );
};

export const OnboardingShippingStep1 = (props) => {
  const { getDynamicReplacement, existsDynamicReplacements } = useDCContext();
  const { profile } = useOperatorContext();
  const charityKey = `charities__${profile.customer.customerCode.toLowerCase()}`;

  const imageSrc = existsDynamicReplacements(`${charityKey}__onboarding_logo`)
    ? getDynamicReplacement(`${charityKey}__onboarding_logo`)
    : undefined;

  const contentText = existsDynamicReplacements(
    `${charityKey}__onboarding_donation_statement`,
  )
    ? getDynamicReplacement(`${charityKey}__onboarding_donation_statement`)
    : undefined;

  return (
    <IndustryStep
      {...props}
      stepKey="shipping__step1"
      contentText={contentText}
      imageSrc={imageSrc}
    />
  );
};

export const OnboardingAviationStep1 = (props) => (
  <IndustryStep {...props} stepKey="aviation__step1" />
);

export const OnboardingAviationStep2 = (props) => (
  <IndustryStep {...props} stepKey="aviation__step2" />
);

export const OnboardingAviationStep3 = (props) => (
  <IndustryStep {...props} stepKey="aviation__step3" />
);
